export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            }
        ],
        searchFields: [
            {
                name: "createdFrom",
                label: "Keletkezés (tól)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "createdTo",
                label: "Keletkezés (ig)",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "appointmentTimeFrom",
                label: "Foglalás időponttól",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "appointmentTimeTo",
                label: "Foglalás időpontig",
                formSize: 3,
                formType: 'date'
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formSize: 3,
                formType: 'text',
            },
            {
                name: "patientName",
                label: "Páciens neve",
                formSize: 3,
                formType: 'text'
            },
            {
                name: "appointmentExtId",
                label: "Külső foglalás ID",
                formSize: 3,
                formType: 'text'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "appointmentId",
                label: "Foglalás ID",
                sort: true,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "appointment",
                label: "Foglalás",
                slot_name: "appointment_format",
                sort: true,
                visibility: true,
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "appointmentDuration",
                label: "Foglalás hossza",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "signCode",
                label: "Szignó kód",
                sort: false,
                visibility: true,
                formType: 'text',
                viewModalShow: true
            },
            {
                name: "patientId",
                label: "Páciens ID",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "patientFullName",
                label: "Páciens neve",
                sort: false,
                visibility: true,
                viewModalShow: true,
                slot_name: "patientNameFormat"
            },
            {
                name: "patientEmail",
                label: "Páciens e-mail",
                sort: false,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "patientPhone",
                label: "Páciens tel.",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "patientAddress",
                label: "Páciens cím",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                sort: false,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "appointmentStatus.text",
                label: "Státusz",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "outdoorAdminEmail",
                label: "Külső admin e-mail",
                sort: false,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "appointmentExtId",
                label: "Külső foglalás ID",
                sort: false,
                visibility: true,
                formType: 'text',
                viewModalShow: true
            },
            {
                name: "errorCode",
                label: "Hibakód",
                sort: false,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "errorDescription",
                label: "Hiba leírás",
                sort: false,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "errorCreated",
                label: "Hiba keletkezés dátuma",
                slot_name: "hist_created_on_format",
                sort: false,
                visibility: true,
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "doctorId",
                label: "Orvos ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contactType",
                label: "Kapcsolat",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "partner",
                label: "Partner",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "treatmentId",
                label: "Kezelés ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "treatmentTitle",
                label: "Kezelés",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "contactId",
                label: "Kapcsolat ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "contact.text",
                label: "Kapcsolat",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "partnerId",
                label: "Partner Id",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "partner.text",
                label: "Partner",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "status",
                label: "Státusz",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "roomId",
                label: "Szoba ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                sort: false,
                visibility: false,
                viewModalShow: false
            },
            {
                name: "companySite.siteName",
                label: "Telephely",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "seen",
                label: "Megnézve?",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                slot_name: "created_on_format",
                sort: false,
                visibility: false,
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                sort: false,
                visibility: false,
                viewModalShow: true
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                slot_name: "modified_on_format",
                sort: false,
                visibility: false,
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
